module.exports = __webpack_public_path__ + "media/images/countryrect/km-36bb196ee81720a9a01bc59c6d84fc20.svg";